// @mui material components
import {
  Snackbar,
  Alert,
  Card,
  Icon,
  // Tooltip,
  CircularProgress,
  Backdrop,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ListItem,
  // ListItemIcon,
  ListItemText,
  Box,
  Typography,
  Divider,
  ListItemIcon,
  Tabs,
  Tab,
  Button,
  // Slider,
  // Stack,
  // LinearProgress,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import PushNotificationMgr from "app/components/push_notification_mgr";

// import PropTypes from "prop-types";

// function CustomTabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// CustomTabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.number.isRequired,
//   value: PropTypes.number.isRequired,
// };

function PromoteIndex() {
  const pageTitle = `Promotion Campaigns`;
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  function emptyCache() {
    if ("caches" in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
  }

  function versionRefresh() {
    emptyCache();
    window.location.reload();
  }

  function appVersionCheck(newVersion) {
    // Handle App Update
    const currentVersion = localStorage.getItem(AppConfig.app_version_store);
    let shouldUpdate = false;
    if (currentVersion !== newVersion) {
      shouldUpdate = true;
    }
    localStorage.setItem(AppConfig.app_version_store, newVersion);

    if (shouldUpdate) {
      if (
        window.confirm(
          "A new version is available. App will automatically refresh to get the latest update."
        ) === true
      ) {
        versionRefresh();
      } else {
        versionRefresh();
      }
    }
  }

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [pageLoaded, setPageLoaded] = useState(false);
  const [promotions, setPromotions] = useState([]);
  const [postedPromotions, setPostedPromotions] = useState([]);
  const [potentialEarning, setPotentialEarning] = useState(0);
  const [agentEarning, setAgentEarning] = useState(0);
  const [progress, setProgress] = useState(0);
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [currency, setCurrency] = useState("");
  const [tabIndex, setTabIndex] = useState(0);
  const [selectedPosted, setSelectedPosted] = useState({});
  const [openEarnAgainDialog, setOpenEarnAgainDialog] = useState(false);

  // Function to normalise the values (MIN / MAX could be integrated)
  // const normalise = (value) => ((value - 0) * 100) / (potentialEarning - 0);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/smm/index.json`)
        .then((result) => {
          setShowLoading(false);
          // console.log(result);
          if (result.data.status === "success") {
            setPromotions(result.data.data.campaigns);
            setPostedPromotions(result.data.data.posted_campaigns);
            setPotentialEarning(result.data.data.potentialEarnings);
            setAgentEarning(result.data.data.agentEarnings);
            setCurrency(result.data.data.currency);
            if (result.data.data.potentialEarnings > 0) {
              setProgressPercentage(
                (result.data.data.agentEarnings / result.data.data.potentialEarnings) * 100
              );
              setProgress(
                (result.data.data.agentEarnings / result.data.data.potentialEarnings) * 100
              );
            }

            // setProgress(normalise(result.data.data.agentEarnings));
            console.log(progress);
          } else {
            setErrMsg(result.data.data.message);
            setSeverity("error");
            setOpen(true);
          }
          setPageLoaded(true);
          appVersionCheck(result.data.version);
        })
        .catch(() => {
          setShowLoading(false);
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setSeverity("error");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  const [allowPushNotificationDialogState, setAllowPushNotificationDialogState] = useState(false);

  function getProgressColor() {
    let color = "dark";
    if (progress <= 25) {
      color = "primary";
    } else if (progress > 25 && progress <= 50) {
      color = "warning";
    } else if (progress > 50) {
      color = "success";
    }

    return color;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PushNotificationMgr
        displayState={allowPushNotificationDialogState}
        setDisplayState={setAllowPushNotificationDialogState}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openEarnAgainDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Want to earn again?</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDTypography variant="h6" fontWeight="light" mb={3}>
            You posted this Ad using your <b>{selectedPosted.handle}</b> {selectedPosted.title}{" "}
            account.
          </MDTypography>
          <MDTypography variant="text" fontWeight="light" mb={3}>
            To earn again, post this Ad using a different {selectedPosted.title} account.
          </MDTypography>
          <br />
          <br />
          <MDTypography variant="text" fontWeight="light" mb={3}>
            <small>
              You can earn much more using all {selectedPosted.title} accounts you have access to.
            </small>
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setSelectedPosted({});
              setOpenEarnAgainDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="primary"
            variant="contained"
            onClick={() => {
              navigate(
                `/promotions/${selectedPosted.campaign.reference}/${selectedPosted.reference}`
              );
            }}
          >
            Proceed
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mt={1.5} pb={3}>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Button
                size="small"
                color="dark"
                startIcon={<Icon>west</Icon>}
                onClick={() => {
                  navigate(`/social`);
                }}
              >
                Back
              </Button>
            </MDBox>
            <MDBox mt={2}>
              <Card sx={{ width: "100%", height: "100%" }}>
                <MDBox p={3}>
                  <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                    Promotion Campaigns
                  </MDTypography>
                  <MDTypography variant="subtitle2" fontSize={15} fontWeight="light" gutterBottom>
                    Become a micro-influencer. Get paid to post advert videos and photos on social
                    media on behalf of brands.
                  </MDTypography>
                  {/* <MDTypography mt={3} variant="h6" fontSize={14} fontWeight="light" gutterBottom>
                    Earn as much as <b>N10,000.00</b> weekly
                  </MDTypography> */}
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={2}>
              <MDBox mt={5}>
                <MDBox mb={3}>
                  <Card>
                    <MDBox p={3}>
                      <MDBox align="center" mb={2}>
                        <MDTypography variant="h6">Your Potential Earnings</MDTypography>
                      </MDBox>
                      <MDBox mt={1} align="center">
                        {potentialEarning > agentEarning ? (
                          <Box sx={{ position: "relative", display: "inline-flex" }}>
                            <CircularProgress
                              variant="determinate"
                              size={80}
                              thickness={3.6}
                              value={progress <= 0 ? progress + 5 : progress}
                              color={getProgressColor()}
                            />
                            <Box
                              sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: "absolute",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Typography
                                variant="caption"
                                component="div"
                                sx={{ color: "text.secondary" }}
                                fontSize={18}
                              >
                                <b>{`${progressPercentage.toFixed(0)}%`}</b>
                              </Typography>
                            </Box>
                          </Box>
                        ) : (
                          <Box sx={{ position: "relative", display: "inline-flex" }}>
                            <CircularProgress
                              variant="determinate"
                              size={80}
                              thickness={3.6}
                              value={100}
                              color="success"
                            />
                            <Box
                              sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: "absolute",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Typography
                                variant="caption"
                                component="div"
                                sx={{ color: "text.secondary" }}
                                fontSize={18}
                              >
                                <b>{`${progressPercentage.toFixed(0)}%`}</b>
                              </Typography>
                            </Box>
                          </Box>
                        )}
                      </MDBox>
                      <MDBox align="center">
                        {potentialEarning > 0 ? (
                          <MDTypography variant="h6" fontWeight="regular">
                            {currency}
                            {(agentEarning / 100).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}{" "}
                            / {currency}
                            {(potentialEarning / 100).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </MDTypography>
                        ) : (
                          <MDTypography variant="h6" fontWeight="regular">
                            {currency}
                            {(potentialEarning / 100).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </MDTypography>
                        )}
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </MDBox>
              <MDBox mt={5}>
                <Card elevation={5}>
                  <MDBox p={1}>
                    <Tabs
                      indicatorColor="primary"
                      textColor="primary"
                      variant="fullWidth"
                      aria-label="full width tabs example"
                      value={tabIndex}
                      onChange={(event, newValue) => setTabIndex(newValue)}
                    >
                      <Tab
                        label={
                          <MDTypography color="dark" variant="subtitle2" fontWeight="bold">
                            <Icon>campaign</Icon>
                            <br />
                            Available
                            <br />
                            Ads
                          </MDTypography>
                        }
                        id="tab-id-0"
                      />
                      <Tab
                        label={
                          <MDTypography color="dark" variant="subtitle2" fontWeight="bold">
                            <Icon>checklist</Icon>
                            <br />
                            Posted
                            <br />
                            Ads
                          </MDTypography>
                        }
                        id="tab-id-1"
                      />
                    </Tabs>
                  </MDBox>
                </Card>
              </MDBox>
              <div
                role="tabpanel"
                hidden={tabIndex !== 0}
                id="simple-tabpanel-0"
                aria-labelledby="simple-tab-0"
              >
                {promotions.length <= 0 ? (
                  <Card sx={{ width: "100%", marginTop: "35px" }}>
                    <MDBox pt={3} pb={2} px={2}>
                      <MDBox
                        component="ul"
                        display="flex"
                        flexDirection="column"
                        p={0}
                        m={0}
                        sx={{ listStyle: "none" }}
                      >
                        <MDTypography variant="h6" fontSize={36} align="center">
                          <Icon>campaign</Icon>
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light" align="center">
                          No available promotions at the moment. Check back later.
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Card>
                ) : (
                  <MDBox
                    mt={5}
                    component="ul"
                    display="flex"
                    flexDirection="column"
                    p={0}
                    sx={{ listStyle: "none" }}
                  >
                    <MDBox mb={1} px={2} display="flex" justifyContent="space-between">
                      <MDTypography variant="h6" fontWeight="regular">
                        <b>Available Adverts:</b>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="regular">
                        {promotions.length}
                      </MDTypography>
                    </MDBox>
                    {promotions.map((record) => (
                      <MDBox
                        mb={2}
                        onClick={() => {
                          // if (subscription === false) {
                          //   setErrMsg("You do not an active subscription to complete this action.");
                          //   setSeverity("error");
                          //   setOpen(true);
                          //   return;
                          // }
                          navigate(`/promotions/${record.campaign.reference}/${record.reference}`);
                        }}
                      >
                        <Card sx={{ width: "100%" }}>
                          <MDBox p={2}>
                            <ListItem key={record.reference} sx={{ py: 1, px: 0 }}>
                              <MDBox align="right" sx={{ height: "100%" }}>
                                <ListItemIcon sx={{ height: "100%" }}>
                                  <MDBox
                                    component="img"
                                    mr={1}
                                    sx={{
                                      width: { xs: 24, md: 36, lg: 36 },
                                    }}
                                    src={`${AppConfig.api_media_url}${record.logo}`}
                                    alt={record.title}
                                  />
                                </ListItemIcon>
                              </MDBox>
                              <ListItemText
                                sx={{ ml: 0 }}
                                primary={
                                  <MDBox>
                                    <MDTypography
                                      variant="h6"
                                      fontWeight="regular"
                                      textTransform="capitalize"
                                      fontSize={13}
                                    >
                                      <b>Ad:</b> {record.campaign.subject}
                                    </MDTypography>
                                  </MDBox>
                                }
                                secondary={
                                  <MDBox mt={0}>
                                    <MDBox mb={0.5}>
                                      <Typography
                                        variant="subtitle2"
                                        fontSize={11}
                                        fontWeight={400}
                                      >
                                        Commission:{" "}
                                        <b>
                                          {currency}
                                          {(record.commission / 100).toLocaleString("en", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })}
                                        </b>
                                      </Typography>
                                      <Typography fontSize={10}>
                                        Followers Required: <b>+{record.min_followers}</b>
                                      </Typography>
                                      <Typography fontSize={10}>
                                        Posted:{" "}
                                        <b>
                                          {record.count} / {record.target}
                                        </b>
                                      </Typography>
                                    </MDBox>
                                  </MDBox>
                                }
                              />
                              <MDBox>
                                <MDBox mt={0} align="right">
                                  <MDButton variant="outlined" iconOnly circular color="primary">
                                    <Icon>chevron_right</Icon>
                                  </MDButton>
                                </MDBox>
                              </MDBox>
                            </ListItem>
                          </MDBox>
                        </Card>
                      </MDBox>
                    ))}
                  </MDBox>
                )}
              </div>
              <div
                role="tabpanel"
                hidden={tabIndex !== 1}
                id="simple-tabpanel-0"
                aria-labelledby="simple-tab-0"
              >
                {postedPromotions.length <= 0 ? (
                  <Card sx={{ width: "100%", marginTop: "35px" }}>
                    <MDBox pt={3} pb={2} px={2}>
                      <MDBox
                        component="ul"
                        display="flex"
                        flexDirection="column"
                        p={0}
                        m={0}
                        sx={{ listStyle: "none" }}
                      >
                        <MDTypography variant="h6" fontSize={36} align="center">
                          <Icon>campaign</Icon>
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light" align="center">
                          You have not posted any ads yet.
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Card>
                ) : (
                  <MDBox
                    mt={5}
                    component="ul"
                    display="flex"
                    flexDirection="column"
                    p={0}
                    sx={{ listStyle: "none" }}
                  >
                    <MDBox mb={1} px={2} display="flex" justifyContent="space-between">
                      <MDTypography variant="h6" fontWeight="regular">
                        <b>Posted Adverts:</b>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="regular">
                        {postedPromotions.length}
                      </MDTypography>
                    </MDBox>
                    {postedPromotions.map((record) => (
                      <MDBox mb={2}>
                        <Card sx={{ width: "100%" }}>
                          <MDBox p={2}>
                            <MDBox>
                              <ListItem key={record.reference} sx={{ py: 1, px: 0 }}>
                                <MDBox align="right" sx={{ height: "100%" }}>
                                  <ListItemIcon sx={{ height: "100%" }}>
                                    <MDBox
                                      component="img"
                                      mr={1}
                                      sx={{
                                        width: { xs: 24, md: 36, lg: 36 },
                                      }}
                                      src={`${AppConfig.api_media_url}${record.logo}`}
                                      alt={record.title}
                                    />
                                  </ListItemIcon>
                                </MDBox>
                                <ListItemText
                                  sx={{ ml: 0 }}
                                  primary={
                                    <MDBox>
                                      <MDTypography
                                        variant="h6"
                                        fontWeight="regular"
                                        textTransform="capitalize"
                                        fontSize={13}
                                      >
                                        <b>Ad:</b> {record.campaign.subject}
                                      </MDTypography>
                                    </MDBox>
                                  }
                                  secondary={
                                    <MDBox mt={1}>
                                      <MDBox mb={0.5}>
                                        <Typography
                                          variant="subtitle2"
                                          fontSize={12}
                                          fontWeight={400}
                                        >
                                          You Earned:{" "}
                                          <b>
                                            {currency}
                                            {(record.commission / 100).toLocaleString("en", {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </b>
                                        </Typography>
                                      </MDBox>
                                    </MDBox>
                                  }
                                />
                                <MDBox>
                                  <MDBox mt={0} align="right">
                                    <MDButton variant="outlined" iconOnly circular color="success">
                                      <Icon>check</Icon>
                                    </MDButton>
                                  </MDBox>
                                </MDBox>
                              </ListItem>
                            </MDBox>
                            <MDBox mt={1}>
                              <Divider />
                            </MDBox>
                            <MDBox mt={2} mb={1} align="center">
                              <MDButton
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  setSelectedPosted(record);
                                  setOpenEarnAgainDialog(true);
                                }}
                              >
                                Earn Again?
                              </MDButton>
                            </MDBox>
                          </MDBox>
                        </Card>
                      </MDBox>
                    ))}
                  </MDBox>
                )}
              </div>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PromoteIndex;
